import React, { useRef, useState, useEffect } from "react";
import CssTransition from "../../../component/layout/css-transition";
import Select from "react-select";
import * as yup from "yup";
import { useFormik } from "formik";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";

// Redux
import { useDispatch } from "react-redux";
import { getAllToDO } from "../../../redux/actions/todo";
import { addOverviewCard } from "../../../redux/actions/overview";

const statusOptions = [
  {
    label: "Completed",
    value: "completed",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "In Progress",
    value: "in progress",
  },
  {
    label: "Overdue",
    value: "overdue",
  },
  {
    label: "Overdue (In Progress)",
    value: "in progress overdue",
  },
  {
    label: "Completed With Delay",
    value: "completed with delay",
  },
];

function AddNewCardModal({
  openModalPopUp,
  setOpenModalPopUp,
  setUpdate,
  update,
}) {
  const modalContent = useRef(null);
  const [todoList, setTodoList] = useState([]);
  const [todoOptions, setTodoOptions] = useState([]);
  const [loader, setLoader] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getAllToDO("", "", "", "", "", "", (res) => {
        setTodoList(res?.data?.activities ? res?.data?.activities : []);
      })
    );
  }, []);

  useEffect(() => {
    if (todoList.length > 0) {
      const modifiedToDo = todoList.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setTodoOptions(modifiedToDo);
    }
  }, [todoList]);

   /* ------------------ Form Validation ---------------- */
   const validationSchema = yup.object({
    todo_id: yup.string().required("To Do is required."),
    status: yup.string().required("To Do status is required."),
  });

  const formik = useFormik({
    initialValues: {
      todo_id: "",
      status: "",
    },
    validationSchema,
    onSubmit: (value) => {
      handleSubmit(value);
    },
  });


  // Function to call Add Card API
  const handleSubmit = (payload) => {
    setLoader(true);
    console.log('payload ----', payload);
    const request = {
      payload,
      onSuccess: () => {
        formik.resetForm();
        setLoader(false);
        setOpenModalPopUp(false);
        setUpdate(update + 1);
      },
      onError: (error) => {
        setLoader(false);
        swal({
          content: <CustomeModal type="error" title="Error!" content={error} />,
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(addOverviewCard(request));
  };

 
  return (
    <>
      <CssTransition
        className="fixed -inset-4 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={openModalPopUp}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={openModalPopUp}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white overflow-auto max-w-md w-full max-h-full rounded-xl shadow-lg flex flex-col"
        >
          <div class="py-8 px-6 space-y-10">
            <div className="space-y-2">
              <h3 class="text-base font-semibold text-[#1E293B] flex justify-center">
                New To Do Card
              </h3>
              <h6 className="text-sm text-[#1E293B] font-normal text-center">
                Please select the to do and respective status for which you want
                to create a new card.
              </h6>
            </div>
            <div className="space-y-4">
              <div className="space-y-1">
                <label
                  for="location"
                  className="block text-sm font-medium text-gray-600"
                >
                  To Do&nbsp;<span className="text-rose-500">*</span>
                </label>
                <Select
                  placeholder="Select To Do"
                  isClearable
                  className="unresetText"
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  name="todo_id"
                  onChange={(e) => formik.setFieldValue("todo_id", e?.value)}
                  onBlur={formik.handleBlur}
                  options={todoOptions}
                  value={formik?.values?.todo_id ? todoOptions.find((item) => item.value === formik.values.todo_id) : null}
                  menuPortalTarget={document.body}
                  classNames={{
                    control: (style) => {
                      return `!border !shadow-sm ${
                        style.isFocused
                          ? "!border-[--bg-color-300]/50"
                          : "!border-slate-200 hover:!border-gray-300"
                      }`;
                    },
                    container: (style) => {
                      return "!h-[37.5px] !font-inter !text-sm";
                    },
                    menuList: (style) => {
                      return `!max-h-[160px]`;
                    },
                    placeholder: (style) => {
                      return `!text-gray-400 !text-md`;
                    },
                  }}
                />
                {formik.errors.todo_id && (
                  <div className="text-xs text-rose-600">
                    {formik.errors.todo_id}
                  </div>
                )}
              </div>
              <div className="space-y-1">
                <label
                  for="location"
                  className="block text-sm font-medium text-gray-600"
                >
                  To Do Status&nbsp;<span className="text-rose-500">*</span>
                </label>
                <Select
                  placeholder="Select To Do Status"
                  className="unresetText"
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  isClearable
                  options={statusOptions}
                  name="status"
                  onChange={(e) => formik.setFieldValue("status", e?.value)}
                  onBlur={formik.handleBlur}
                  value={formik?.values?.status ? statusOptions.find((item) => item.value === formik.values.status) : null}
                  menuPortalTarget={document.body}
                  classNames={{
                    control: (style) => {
                      return `!border !shadow-sm ${
                        style.isFocused
                          ? "!border-[--bg-color-300]/50"
                          : "!border-slate-200 hover:!border-gray-300"
                      }`;
                    },
                    container: (style) => {
                      return "!h-[37.5px] !font-inter !text-sm";
                    },
                    menuList: (style) => {
                      return `!max-h-[160px]`;
                    },
                    placeholder: (style) => {
                      return `!text-gray-400 !text-md`;
                    },
                  }}
                />
                {formik.errors.status && (
                  <div className="text-xs text-rose-600">
                    {formik.errors.status}
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <button
                className="btn bg-[#fff] border-slate-200 hover:border-slate-300 text-slate-600 grow"
                onClick={() => {
                  setOpenModalPopUp(false);
                  formik.resetForm()
                }}
              >
                Cancel
              </button>
              <button
                className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white grow"
                onClick={formik.handleSubmit}
              >
                {loader ? (
                  <span className="ml-2">
                    <svg
                      className="animate-spin w-4 h-4 fill-current shrink-0"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                    </svg>
                  </span>
                ) : (
                  "Create"
                )}
              </button>
            </div>
          </div>
        </div>
      </CssTransition>
    </>
  );
}

export default AddNewCardModal;
